var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "obs-box" },
      _vm._l(_vm.iObs.imgList, function (img, idx) {
        return _c("div", { key: idx, staticClass: "img-box" }, [
          _c("div", { staticClass: "desc-top" }, [_vm._v(_vm._s(img.desc))]),
          _c("div", { staticClass: "desc-bottom" }, [_vm._v(_vm._s(img.desc))]),
          _c("img", {
            ref: "imgEls",
            refInFor: true,
            attrs: { src: img.src },
            on: { load: _vm.addIntersectionObs },
          }),
        ])
      }),
      0
    ),
    _c("div", [
      _c("div", [_vm._v(_vm._s(_vm.$Device.deviceInfo()))]),
      _vm.$isBrowserAvailable([
        ["chrome", 69],
        ["safari", 16.4],
      ])
        ? _c("div", [
            _c("span", [_vm._v("이 브라우저에서 사용할 수 있습니다.")]),
          ])
        : _c("div", [
            _c("span", [_vm._v("이 브라우저에서 사용할 수 없습니다.")]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }